import type { HomePreviewModel } from '@/components/user_catalog/home_page/homePreviewModel';
import type { HeroDraft, SectionsDraft } from './homeDraft';

/** Overlays the tabs' live drafts onto fetched state, per tab independently:
 * a tab that has been edited wins outright (including cleared fields), an
 * untouched one keeps previewing what the server holds. */
export const resolveHomePreview = (
  server: { hero: HeroDraft; sections: SectionsDraft },
  drafts: { hero?: HeroDraft; sections?: SectionsDraft }
): HomePreviewModel => {
  const hero = drafts.hero ?? server.hero;
  const sections = drafts.sections ?? server.sections;

  return {
    hero: {
      name: hero.name,
      description: hero.description,
      publicationIds: hero.publication_ids,
    },
    sections: sections.rows.map((row) => ({
      collectionId: row.collection_id,
      displayMode: row.display_mode,
    })),
  };
};
